import React, { useEffect, useState } from "react";
import './styles.scss';
import { Form, Input, Modal, Select } from "antd";
import { CashDeskFormProps } from "./types";
import { useCashDesk } from "../../../Services/useCashDesk";
import { useGetBranch } from "../../../Services/useGetBranch";
import { useGetCurrency } from "../../../Services/useGetCurrency";

export interface FilterValues{
    value: string,
    id: string,
    key: string,
  }
export interface CashDeskValuesForm {
    name: string,
    description: string,
    branch?: FilterValues,
    currency?: FilterValues,
    balance?: string, 
   // type?: FilterValues
}

export const CashDeskForm: React.FC<CashDeskFormProps> =({
    openForm,
    callback,
    rowSelect,
    form_cash_desk
})=>{

    
    const [loadingBtn, setLoadingBtn] = useState(false)
    const { createCashDesk, editCashDesk} = useCashDesk()
    const { Option} = Select

    const { data: branch }= useGetBranch()
    const { data: currency} = useGetCurrency()

    const mandatory = [
        {
            required: true,
            message:'Este campo es obligatorio'
        }
    ]  

    useEffect(()=>{
        form_cash_desk.resetFields()
    },[])

    const handleCancel =()=>{
        callback()
    }

    const handleSave = async (values: CashDeskValuesForm)=>{
        let newValues
        const editValues = {
            name: values.name,
            description: values.description                       
        }
        
        if(values &&
            values.name &&
            values.branch &&
            values.branch.key &&
            values.currency &&
            values.currency.key &&
            values.balance 
        ){
            newValues = {
                name: values.name,
                description: values.description,
                branch_id: values.branch.key,
                currency_id: values.currency.key,
                balance: values.balance,
                type_id: '2'
            }
        }     
        
        if(rowSelect){
            await editCashDesk(handleCancel, rowSelect.id, editValues)
        }else if(newValues){
            await createCashDesk(handleCancel, newValues)
        }
    }    

    return(
        <div>
            <Modal
                title= {rowSelect ? 'Editar Caja' : 'Crear Caja'}
                open={openForm}
                onCancel={handleCancel}  
                confirmLoading={loadingBtn}                   
                okText="Guardar"
                cancelText="Cancelar" 
                onOk={()=>form_cash_desk.submit()}
            >
                <Form
                    form={form_cash_desk}
                    id='form_cash_desk'
                    onFinish={handleSave}
                    layout="vertical"
                    
                >
                    <Form.Item
                        label='Nombre'
                        name='name'
                        initialValue={rowSelect?.name}
                        rules={mandatory}
                    >
                            <Input
                                placeholder="Nombre"
                            />

                    </Form.Item>   
                    { !rowSelect && 
                        <>                                                                 
                            <Form.Item
                                label='Sucursal'
                                name='branch'
                                rules={mandatory}
                            >
                                <Select
                                    labelInValue   
                                    placeholder='Seleccione una sucursal'                                   
                                >
                                    {branch && branch.map((item) => (
                                        <Option
                                        value={item.name} key={item.id}>
                                            {item.name}
                                        </Option>
                                    ))} 
                                </Select>
                            </Form.Item>  
                            <Form.Item
                                label='Moneda'
                                name='currency'
                                rules={mandatory}
                            >
                                <Select
                                    labelInValue  
                                    placeholder= ' Seleccione una moneda'                                           
                                >
                                    {currency && currency.map((item) => (
                                        <Option value={item.name} key={item.id}>
                                        {item.name}
                                        </Option>
                                    ))} 
                                </Select>
                            </Form.Item>  
                            <Form.Item
                                label='Balance'
                                name='balance'
                                rules={mandatory}
                            >
                                <Input
                                    placeholder='Ingrese monto de inicio'
                                    type= 'number'
                                />
                            </Form.Item>   
                        </> 
                    }   
                    <Form.Item
                        label='Descripción'
                        name='description'
                        initialValue={rowSelect?.description}
                    >
                        <Input
                            placeholder="Descripción"
                        />
                    </Form.Item> 
                </Form>
            </Modal>
        </div>
    )
}

export default CashDeskForm;